import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});

export const fetchSettingsData = createAsyncThunk(
  "settings/fetchByIdStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.get("/settings-data");
      if (response.data.status_code === 200) {
        return response.data.data;
      }
    } catch (error) {}
  }
);
const initialState = {
  settingDatas: [],
  loading: true,
  error: null,
};

const settingDataList = createSlice({
  name: "settingsdata",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettingsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSettingsData.fulfilled, (state, action) => {
        state.settingDatas = action.payload;
        state.loading = false;
      })

      .addCase(fetchSettingsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "error redux found";
      });
  },
});

export default settingDataList.reducer;
